// ======================================================================
// PrerollFormModalVideoExt.jsx — create / edit PREROLL VIDEO (UTC ⇆ locale)
// ======================================================================
import React, { useState, useEffect } from 'react'
import Modal   from '../common/Modal'
import Loader  from '../Utils/Loader'
import api     from '../../services/api'
import { toBase64 } from '../Utils/file'
import { DateTime } from 'luxon'
import '../../css/prerollFormModal.css'

const API_BASE = '/prerolls-ext'

/* ───────── helpers ───────── */
const toInputDT = v => {
  if (!v) return ''
  const dt = v.includes('T')
    ? DateTime.fromISO(v, { zone: 'utc' })
    : DateTime.fromSQL(v, { zone: 'utc' })
  return dt.setZone('local').toFormat("yyyy-MM-dd'T'HH:mm")
}

const toUtcSql = s =>
  DateTime
    .fromFormat(s, "yyyy-MM-dd'T'HH:mm", { zone: 'local' })
    .toUTC()
    .toFormat('yyyy-MM-dd HH:mm:ss')

const EMPTY = {
  startTime:'', endTime:'', type:'base', prio:0,
  mediaBase64:'', originalFilename:'', mediaType:'video'
}

/* ───────── component ───────── */
export default function PrerollFormModalVideoExt({ open, onClose, editing, onSaved }) {
  const [data,   setData]   = useState(EMPTY)
  const [busy,   setBusy]   = useState({ media:false })
  const [saving, setSaving] = useState(false)
  const isEdit = Boolean(editing)

  useEffect(() => {
    if (isEdit && editing) {
      setData({
        ...EMPTY,
        ...editing,
        startTime: toInputDT(editing.startTime),
        endTime  : toInputDT(editing.endTime),
      })
    } else setData(EMPTY)
  }, [isEdit, editing])

  /* handlers */
  const handleChange = e =>
    setData({ ...data, [e.target.name]: e.target.value })

  const pickFile = async e => {
    const file = e.target.files[0]; if (!file) return
    setBusy({ media:true })
    const b64 = await toBase64(file)
    setData(d => ({ ...d, mediaBase64:b64, originalFilename:file.name }))
    setBusy({ media:false })
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (busy.media || saving) return
    setSaving(true)
    try {
      const payload = {
        ...data,
        startTime: toUtcSql(data.startTime),
        endTime  : toUtcSql(data.endTime),
      }
      isEdit
        ? await api.put(`${API_BASE}/${editing.id}`, payload)
        : await api.post(API_BASE, payload)

      onSaved()
      onClose()
    } catch (err) {
      console.error(err)
      alert('Errore salvataggio preroll')
    } finally { setSaving(false) }
  }

  /* render */
  return (
    <Modal open={open} onClose={onClose}>
      {/* overlay loader (salvataggio) */}
      {(saving || busy.media) && (
        <div className="modal-loader-overlay">
          <Loader />
        </div>
      )}

      <h3 className="preroll-modal-title">
        {isEdit ? 'Modifica preroll' : 'Nuovo preroll (video)'}
      </h3>

      <form className="rr-form rr-modal-scroll" onSubmit={handleSubmit}>
        <label>Inizio
          <input type="datetime-local" name="startTime" value={data.startTime}
                 onChange={handleChange} required />
        </label>
        <label>Fine
          <input type="datetime-local" name="endTime" value={data.endTime}
                 onChange={handleChange} required />
        </label>

        <div className="rr-row">
          <label>Tipo
            <select name="type" value={data.type} onChange={handleChange}>
              <option value="base">Pubblicità</option>
              <option value="first">Primo</option>
              <option value="last">Ultimo</option>
            </select>
          </label>
          <label>Ordine
            <input type="number" name="prio" min="0" max="10"
                   value={data.prio} onChange={handleChange} />
          </label>
        </div>

        <label>File video (mp4)
          <input type="file" accept="video/*"
                 onChange={pickFile} required={!isEdit} />
        </label>
        {busy.media && <Loader small />}

        <div className="rr-actions">
          <button type="button" className="btn-cancel" onClick={onClose}>Annulla</button>
          <button type="submit" className="btn-save" disabled={busy.media || saving}>
            {(busy.media || saving) ? <Loader small /> : 'Salva'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
